export function portableTextToPlainText(value) {
  if (!Array.isArray(value)) {
    return ''
  }

  return value
    .map((block) => {
      if (!block || block._type !== 'block' || !Array.isArray(block.children)) {
        return ''
      }

      return block.children
        .map((child) => ('text' in child ? child.text : ''))
        .join('')
        .trim()
    })
    .filter(Boolean)
    .join('\n')
    .trim()
}

export function isPortableTextEmpty(value) {
  const plain = portableTextToPlainText(value)
  return plain.length === 0
}
